<template>
  <div class="chart-card">
    <component
      :is="type"
      class="amn-chart"
      :chart-data="data"
    />
  </div>
</template>

<script>
  import bar from './bar';
  import bubble from './bubble';
  import doughnut from './doughnut';
  import pie from './pie';
  import polarArea from './polarArea';
  import radar from './radar';
  import scatter from './scatter';
  import horizontalBar from './horizontalBar';
  import lineChart from './line';

  export default {
    name: 'ChartCard',
    components: {
      'bar': bar,
      'bubble': bubble,
      'doughnut': doughnut,
      'pie': pie,
      'polarArea': polarArea,
      'radar': radar,
      'scatter': scatter,
      'horizontalBar': horizontalBar,
      'lineChart': lineChart,
    },
    props: {
      type: {
        type: String,
        default: 'bar',
        validator: function (value) {
          return ['bar', 'lineChart', 'bubble', 'doughnut', 'pie', 'polarArea', 'radar', 'scatter', 'horizontalBar'].indexOf(value) !== -1
        }
      },
      data: {required: true},
      title: {type: String, default: undefined},
    },
    data() {
      return {};
    },
    computed: {},
    created() {
    }
  }
</script>


<style scoped>
  .amn-chart {
    margin: 5px;
  }

  .chart-card {
    padding: 0;
    margin: 5px;
    text-decoration: none;
  }
</style>
